import Container, { Service } from 'typedi';

import { WindowToken } from '../../../injection-tokens';
import { Utils } from '../../utils';
import { UrlUtils } from '../../utils/urlUtils';
import { AuthenticationType } from '../enums';
import { IAuthenticationData, IRegularLoginModel } from '../models';
import { LoginDataBuilder } from './logindata.builder.service';
import { IMrGreenMigration } from '../../mr-green-migration/models/interfaces/IMrGreenMigration';
import { loadMrGreenMigration } from '../../mr-green-migration/mr-green-migration.loader';
import PageContextManager from 'page-context-manager';

@Service()
export class RegularLoginDataBuilder extends LoginDataBuilder<IRegularLoginModel> {
    private readonly _window: Window;
    private readonly _urlUtils: UrlUtils;
    private readonly _utils: Utils;
    private _mrGreenMigration?: IMrGreenMigration;

    constructor() {
        super();

        this._window = Container.get(WindowToken);
        this._urlUtils = Container.get(UrlUtils);
        this._utils = Container.get(Utils);
    }

    public Build = async (data: any): Promise<IRegularLoginModel> => {
        const productPackage: number = PageContextManager.getDeviceData().productPackage;
        const authenticationInfo: IAuthenticationData = data?.authenticationdata;

        const errorCode = this._urlUtils.getParameterByName('ErrorCode') || undefined;
        const reasonCode = this._urlUtils.getParameterByName('ReasonCode') || undefined;

        let loginModel: IRegularLoginModel = {
            LangID: PageContextManager.getLocalizationData().langIso3,
            LoginType: AuthenticationType.Login,
            BrandID: PageContextManager.getBrandData().brandId,
            SubBrandId: PageContextManager.getBrandData().subBrandId,
            AuthenticationInfo: JSON.stringify(authenticationInfo),
            TargetProductPackage: productPackage,
            SourceProductPackage: productPackage,
            ClientVersion: PageContextManager.getDeviceData().clientVersion,
            ScreenHeight: screen.height,
            ScreenWidth: screen.width,
            Benchmark: 0,
            DevicePixelRatio: this._window.devicePixelRatio,
            ErrorCode: isNaN(Number(errorCode)) ? undefined : Number(errorCode),
            ReasonCode: reasonCode,
            GASessionID: this._utils.GetGALinkerParam(),
            TestData: await this._utils.GetSCutTestData(),
        };

        await this._setLoginNativeProps(loginModel);

        this._mrGreenMigration = await loadMrGreenMigration();
        if (this._mrGreenMigration) {
            loginModel.BusinessCorrelationID = this._mrGreenMigration.BusinessCorrelationId;
            loginModel.PlayerMigratedCookieExist = this._mrGreenMigration.PlayerMigratedCookieExist;
        }

        return loginModel;
    };
}
